function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { formValueSelector } from "redux-form";
import { FaCalculator } from "react-icons/fa";
import { PiShoppingCart, PiHandDeposit } from "react-icons/pi";
import NumericFormat from "../../../../components/react-number-format/NumericFormat";
import Alert from "@mui/material/Alert";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "../../../../components/mui/material/Button";
import NumericFormatTextField from "../../../../components/redux-form/NumericFormatTextField";
import { loadUnitDecimalScalesByInvestmentItemIdIn } from "../../../../actions";
import { operationTypes, investmentItemTypeIds, calculateUnitDecimalScaleValue, roundDown } from "../../../../constants";
import { t } from "i18next";
var tKey = "contexts.ExchangeContext.CreateExchangeDialog.ExchangeWizardForm.ExchangeWizardFormInvestmentItemAmountStep";
var selector = formValueSelector("exchangeWizard");
function ExchangeWizardFormInvestmentItemAmountStep(props) {
  var price = useSelector(function (state) {
    return selector(state, "price");
  });
  var currency = price.currency;
  var currencyUnitDecimalScales = useSelector(function (state) {
    return state.entities.unitDecimalScales.byInvestmentItemId[currency.id];
  });
  var type = useSelector(function (state) {
    return selector(state, "type");
  });
  var boost = useSelector(function (state) {
    return selector(state, "boost");
  });
  var broker = useSelector(function (state) {
    return selector(state, "broker");
  });
  var investmentItem = useSelector(function (state) {
    return selector(state, "variantInvestmentItemRoot");
  });
  var investmentItemUnitDecimalScales = useSelector(function (state) {
    return state.entities.unitDecimalScales.byInvestmentItemId[investmentItem.id];
  });
  var currencyAmountAvailable = useSelector(function (state) {
    return selector(state, "currencyAmountAvailable");
  });
  var engagedCurrencyAmount = useSelector(function (state) {
    return selector(state, "engagedCurrencyAmount");
  });
  var requestedCurrencyAmount = useSelector(function (state) {
    return selector(state, "requestedCurrencyAmount");
  });
  var investmentItemAmountAvailable = useSelector(function (state) {
    return selector(state, "investmentItemAmountAvailable");
  });
  var quote = useSelector(function (state) {
    return selector(state, "quote");
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    sellAll = _useState2[0],
    setSellAll = _useState2[1];
  var investmentItemUnitDecimalScaleValue = boost ? 15 : investmentItemUnitDecimalScales && investmentItemUnitDecimalScales.length > 0 && calculateUnitDecimalScaleValue(investmentItemUnitDecimalScales, broker);
  var currencyUnitDecimalScaleValue = currencyUnitDecimalScales && currencyUnitDecimalScales.length > 0 && calculateUnitDecimalScaleValue(currencyUnitDecimalScales, broker);
  useEffect(function () {
    props.loadUnitDecimalScalesByInvestmentItemIdIn([investmentItem.id, currency.id]);
  }, [investmentItem.id, currency.id]);
  useEffect(function () {
    if (sellAll) {
      props.change("all", true);
      props.change("investmentItemAmount", investmentItemAmountAvailable);
      props.change("requestedCurrencyAmount", investmentItemAmountAvailable * price.value);
    } else {
      props.resetSection("all");
      props.resetSection("investmentItemAmount");
      props.resetSection("requestedCurrencyAmount");
    }
  }, [sellAll]);
  function toggleSellAll() {
    setSellAll(!sellAll);
  }
  return /*#__PURE__*/React.createElement("div", null, investmentItem.type.id === investmentItemTypeIds.FUND || investmentItem.type.id === investmentItemTypeIds.CRYPTO ? /*#__PURE__*/React.createElement(NumericFormatTextField, {
    fullWidth: true,
    name: "requestedCurrencyAmount",
    id: "requestedCurrencyAmount",
    onValueChangeCallback: function onValueChangeCallback(value) {
      var investmentItemAmount = roundDown(value / price.value, investmentItemUnitDecimalScaleValue);
      props.change("investmentItemAmount", investmentItemAmount);
    },
    inputMode: "numeric",
    placeholder: t("".concat(tKey, ".requestedCurrencyAmount_placeholder")),
    allowNegative: false,
    fixedDecimalScale: true,
    decimalScale: currencyUnitDecimalScaleValue,
    suffix: " ".concat(currency.unitAbbreviation),
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(FaCalculator, null))
    },
    disabled: boost || quote || sellAll
  }) : /*#__PURE__*/React.createElement(NumericFormatTextField, {
    fullWidth: true,
    name: "investmentItemAmount",
    id: "investmentItemAmount",
    onValueChangeCallback: function onValueChangeCallback(value) {
      return props.change("requestedCurrencyAmount", value * price.value);
    },
    inputMode: "numeric",
    placeholder: t("".concat(tKey, ".investmentItemAmount_placeholder")),
    allowNegative: false,
    fixedDecimalScale: true,
    decimalScale: investmentItemUnitDecimalScaleValue,
    suffix: " ".concat(investmentItem.unitAbbreviation),
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(FaCalculator, null))
    },
    disabled: boost || quote || sellAll
  }), type === operationTypes.SELL && /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    color: "link",
    style: {
      fontWeight: 600
    },
    onClick: toggleSellAll
  }, sellAll ? t("".concat(tKey, ".sellPart")) : t("".concat(tKey, ".sellAll"))), !boost && type === operationTypes.BUY && !Number.isNaN(requestedCurrencyAmount) && requestedCurrencyAmount && requestedCurrencyAmount > currencyAmountAvailable && /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    sx: {
      alignItems: "center",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".insufficientCash"),
    components: {
      amount: /*#__PURE__*/React.createElement(NumericFormat, {
        displayType: "text",
        decimalScale: currency.unitDecimalScale,
        value: requestedCurrencyAmount - currencyAmountAvailable,
        className: "me-1",
        style: {
          fontWeight: 600
        }
      }),
      small: /*#__PURE__*/React.createElement("small", null),
      b: /*#__PURE__*/React.createElement("b", null),
      cartIcon: /*#__PURE__*/React.createElement(PiShoppingCart, null),
      depositIcon: /*#__PURE__*/React.createElement(PiHandDeposit, null)
    },
    values: {
      unitAbbreviation: currency.unitAbbreviation,
      brokerName: broker.name
    }
  })));
}
export default connect(undefined, {
  loadUnitDecimalScalesByInvestmentItemIdIn: loadUnitDecimalScalesByInvestmentItemIdIn
})(ExchangeWizardFormInvestmentItemAmountStep);
ExchangeWizardFormInvestmentItemAmountStep.propTypes = {
  loadUnitDecimalScalesByInvestmentItemIdIn: PropTypes.func
};